<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-text-field
              v-model="competence"
              :rules="competenceRules"
              label="Competência"
              prepend-icon="event"
              class="purple-input"
              :value="current_date"
              @keyup.enter="validate"
              mask="##/####"
            />
          </v-flex>

          <v-flex xs12 md4>
            <v-autocomplete
              label="Concessionária"
              :items="utilityCompanies"
              :item-text="utilityCompanyText"
              return-object
              v-model.lazy="utility_company"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-flex xs6 md6 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :loading="loading"
                small
                outline
                slot="start"
              >
                <v-icon>search</v-icon>Buscar
              </v-btn>
            </v-flex>
            <v-spacer />
            <v-flex xs6 md6 v-if="isAdmin || isFinancial">
              <v-btn
                color="success"
                @click="addFares"
                :disabled="loading"
                small
                outline
                slot="end"
              >
                <v-icon class="pr-1">receipt_long</v-icon>Adicionar
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <FaresModal
      v-if="showFaresModal"
      :key="key"
      type="new"
      :showFaresDialog="showFaresModal"
      @closeDialog="closeDialog"
    />
  </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    valid: false,
    invoices: [],
    current_date: new Date(),
    competence: "",
    competenceRules: [
      (v) =>
        !(v.substr(2, 4) < 2019) ||
        !v ||
        "Por favor, o ano deve ser valido. " + v.substr(2, 4),
      (v) =>
        !(v.substr(0, 2) > 12) ||
        !v ||
        "Por favor, o mes deve ser valido. " + v.substr(0, 2),
    ],
    utility_company: "",
    color: null,
    colors: ["purple", "info", "success", "warning", "error", "red", "green"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: null,
    snackbar: false,
    showFaresModal: false,
    key: 0,
  }),

  components: {
    FaresModal: () => import("./FaresModal"),
  },

  async created() {
    if (this.filters && this.filters.competence) {
      this.competence = this.filters.competence;
    }
  },
  computed: {
    ...mapState(["user"]),
    ...mapState("billing", ["loading", "faresItems"]),
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapGetters("configuration", ["utilityCompanyId"]),

    utilityCompanyId() {
      return this.utility_company
        ? this.utilityCompanyId(this.utility_company)
        : "";
    },

    //Permissions
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.getUtilityCompanies();
  },

  methods: {
    ...mapActions("configuration", ["getUtilityCompanies"]),
    ...mapActions("billing", ["getFaresByParams"]),

    addFares() {
      this.key += 1;
      this.showFaresModal = true;
    },

    closeDialog(message, color) {
      this.showFaresModal = false;
      this.snack(message, color, true);
    },

    async validate() {
      if (this.$refs.form.validate()) {
        let params = null;
        if (this.competence || this.utility_company) {
          params = {
            competence: this.competence,
            utility_company: this.utility_company.id,
          };
        }
        this.valid = true;
        await this.getFaresByParams(params);
      }
    },

    utilityCompanyText(item) {
      return `${item.name} - ${item.state}`;
    },

    snack(message, color, snackbar) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = snackbar;
    },

    showSnack(text, color) {
      this.snack(text, color);
    },
  },
};
</script>
